import React from 'react'
import PropTypes from 'prop-types'
import './styles'

import humanize from 'underscore.string/humanize'
import Model from '/lib/model'

import DropdownButton   from 'react-bootstrap/lib/DropdownButton'
import MenuItem         from 'react-bootstrap/lib/MenuItem'
import StateLabel       from './index'

import withAbility    from '/lib/with-ability'
import withSession    from '/lib/with-session'

agent_hidden_ticket_actions = $w 'admin_void_without_refund cancel'
danger_ticket_actions       = $w 'admin_void admin_void_without_refund cancel'

export default \
withAbility \
withSession \
class StateActions extends React.Component
  constructor: ->
    super arguments...
    @state =
      inFlight: false

  @propTypes:
    model:    PropTypes.instanceOf(Model).isRequired
    onClick:  PropTypes.func.isRequired
    position: PropTypes.oneOf ['right', 'left', null]

  @defaultProps:
    position: 'right'


  onClick: (method, name, verify=false)->
    return unless confirm name if verify

    @setState inFlight: true

    @props.onClick method
    .then =>
      @setState inFlight: false
    .catch =>
      @setState inFlight: false

  render: ->
    cn = @props.model.constructor.className
    { className, model: { state, transitions, confirmations } } = @props
    title = if @state.inFlight then 'saving...' else humanize state
    is_agent = @props.session?.user?.role is 'Agent'

    attrs = {}
    attrs.pullRight = true if @props.position is 'right'

    if Object.keys(transitions)?.length
      <DropdownButton
        {attrs...}
        id={"#{cn}-#{@props.model._key}-actions"}
        className="StateActions #{cn} #{state} #{className}"
        title={title}
      >
        {for action, name of transitions
          if action is '---'
            <MenuItem key={name} divider />
          else if cn is 'Ticket' and is_agent and action in agent_hidden_ticket_actions
            null
          else
            has_permission = @props.can action, cn
            confirmation = confirmations?[action]
            onclick = @onClick.bind(@, action, confirmation, !!confirmation) if has_permission
            is_danger = cn is 'Ticket' and action in danger_ticket_actions

            <MenuItem
              key={action}
              className={'danger' if is_danger}
              onClick={onclick}
              disabled={not has_permission}
            >
              {name}
            </MenuItem>
        }
      </DropdownButton>
    else
      <StateLabel {@props...}/>
